<template>
  <section>
    <notifications></notifications>
    <sidebar-help
      :title="$route.meta.title"
      :items="guides"
      :loader="loader"
      :toggleSidebar="visibleSideBar"
      @closeSidebar="closeSidebar"
    />
    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-4 col-md-6 col-sm-6 col-5 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-6 col-7 text-right">
          <div class="box-buttons">
            <base-button
              v-if="selectedRows.length > 0 && canUserDelete"
              type="outline-neutral"
              class="min-button btn-line-danger mr-2"
              @click="deleteMany(selectedRows)"
            >
              <i class="flaticon-delete icon-no-margin"></i>
              <strong class="d-lg-block d-none">Delete</strong>
            </base-button>
            <base-button
              v-if="canUserCreate"
              type="primary"
              @click="$router.push('/rates/new')"
              class="min-button"
            >
              <i class="flaticon-plus"></i>New
              <strong class="d-lg-block d-none ml-1"> Rate</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="main-buttons">
        <div class="row">
          <div
            class="col-xl-5 col-lg-6 col-md-7 col-sm-8 col-12 align-self-center mb-0"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search-2 py-0">
                <b-input-group-prepend class="pt-1 pl-1 d-none">
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>

                <el-select
                  placeholder="Select Destination"
                  v-model="branch"
                  id="branch_name"
                  name="branch_name"
                  filterable
                  reserve-keyword
                  :filter-method="filterOptions"
                  @change="selectedBranch"
                  value
                  class="select-filter d-inline-flex"
                  clearable
                >
                  <el-option
                    v-for="branch in branches"
                    :value="branch._id"
                    :label="getDestinationName(branch)"
                    :key="branch._id"
                  >
                    <span class="hide-data-inline ft-l">{{ branch.name }}</span>
                    <span class="hide-data-inline option-right ft-r">{{
                      branch.supplier.businessDetails.name
                    }}</span>
                  </el-option>
                </el-select>
              </b-input-group>
            </b-form-group>
          </div>
          <div
            class="col-xl-7 col-lg-6 col-md-5 col-sm-4 col-12 text-right align-self-center"
          >
            <div>
              <div class="box-buttons">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral "
                  title="Actions"
                  v-if="currentBranch"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-folder"></i>
                    <strong>Update Rates</strong>
                  </base-button>
                  <div
                    class="dropdown-item"
                    @click="downloadFormatToUpdateRates(currentBranch._id)"
                  >
                    <i class="flaticon-downloading-files"></i> Download template
                  </div>
                  <div class="dropdown-item" @click="upload">
                    <i class="flaticon-arrow-up"></i>Upload template
                  </div>
                  <input
                    type="file"
                    ref="fileInput"
                    accept=".csv"
                    class="d-none"
                    @change="updatedRatesByBranch"
                  />
                </base-dropdown>
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral "
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-rec"></i>
                    <strong>Status</strong>
                  </base-button>
                  <div
                    class="dropdown-item"
                    :class="rateStatus === 'ALL' ? 'active' : ''"
                    @click="applyFilterByStatus('ALL')"
                  >
                    <i class="flaticon-rec text-primary mr-2"></i>
                    All
                  </div>
                  <div
                    class="dropdown-item"
                    :class="rateStatus === 'ACTIVE' ? 'active' : ''"
                    @click="applyFilterByStatus('ACTIVE')"
                  >
                    <i class="flaticon-bold-check-3 text-success mr-2"></i>
                    Active
                  </div>
                  <div
                    class="dropdown-item"
                    :class="rateStatus === 'INACTIVE' ? 'active' : ''"
                    @click="applyFilterByStatus('INACTIVE')"
                  >
                    <i class="flaticon-bold-cancel text-danger mr-2"></i>
                    Inactive
                  </div>

                  <div
                    class="dropdown-item"
                    :class="rateStatus === 'EXPIRED' ? 'active' : ''"
                    @click="applyFilterByStatus('EXPIRED')"
                  >
                    <i class="flaticon-time-left text-neutral mr-2"></i>
                    Expired
                  </div>
                </base-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box-table">
        <div class="row">
          <div
            class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2"
          >
            <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
              <b-form-radio-group
                id="radio-group-2"
                v-model="filterStatus"
                :aria-describedby="ariaDescribedby"
                name="radio-sub-component"
                button-variant="type-tab"
                buttons
                @change="filteredTab"
                class="buttons-rows-2"
              >
                <b-form-radio value="ALL">All</b-form-radio>
                <b-form-radio value="EXPIRED"
                  >Expired<badge type="danger" class="square">{{
                    expiredNumber
                  }}</badge></b-form-radio
                >
              </b-form-radio-group>
            </b-form-group>
          </div>

          <div
            class="col-xl-7 col-lg-5 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 align-self-center mb-lg-0 mb-1 text-right"
          >
            <div class="col-xl-7 col-lg-12 col-md-6 ml-auto d-inline-block">
              <b-form-group
                label="Sort"
                label-for="sort-by-select"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                v-slot="{ ariaDescribedby }"
                class="mb-2"
                size="sm"
              >
                <b-input-group>
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="sortOptions"
                    @change="applySortBy"
                    :aria-describedby="ariaDescribedby"
                    class="w-70"
                    size="sm"
                  >
                    <template #first>
                      <option value="">-- None --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    @change="applySortType"
                    :aria-describedby="ariaDescribedby"
                    class="w-30"
                    size="sm"
                  >
                    <option :value="'asc'">Asc</option>
                    <option :value="'desc'">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2 mb-2">
              <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="view"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="changeViewCard"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card"
                    ><i class="flaticon-menu" title="View Card"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2 mb-2">
              <el-tooltip
                content="Manage columns"
                placement="bottom"
                class="d-inline-flex"
              >
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="modalManageColumn = true"
                >
                  <i class="flaticon-bold-settings mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>

            <div v-if="canUserExport" class="d-inline-block mr-2 mb-2">
              <el-tooltip content="Export" placement="bottom">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="div"
                  title-tag="a"
                  title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
                  title="Export"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-downloading-files mr-0 mt-2"></i>
                  </base-button>

                  <div
                    class="dropdown-item"
                    @click="download(selectedRows)"
                    v-if="selectedRows.length > 0"
                  >
                    Selected Records
                  </div>
                  <div class="dropdown-item" @click="download()">
                    All Records
                  </div>
                </base-dropdown>
              </el-tooltip>
            </div>
            <div class="d-inline-block">
              <el-tooltip content="Help" placement="bottom">
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="openSideBar"
                >
                  <i class="flaticon-question-1 f-16 mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>

        <pagination-block
          :pageCount="rates.pages"
          v-model="currentPage"
          :total="rates.count"
          :limit="limit"
          @changeLimit="changeLimit"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="preventPaginations"
          position="bottom"
        ></pagination-block>

        <b-table
          hover
          :items="items"
          :fields="fields"
          sort-by.sync="created_at"
          sort-asc.sync="true"
          selectable
          @row-selected="onRowSelected"
          select-mode="multi"
          ref="selectableTable"
          sort-icon-left
          responsive
          show-empty
          empty-filtered-text="There are no records matching your request"
          empty-text="There are no records to show"
          :stacked="cardview"
        >
          <template #head()="{ label, field: { key } }">
            <span v-if="key === 'selected'">
              <span
                @click="clearSelected"
                v-if="selectedRows.length === items.length"
                class="check-table selected"
              ></span>

              <span @click="selectAllRows" v-else class="check-table"></span>
            </span>
            <span v-else>{{ label }}</span>
          </template>
          <template #cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true" class="check-table selected"></span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true" class="check-table"></span>
              <span class="sr-only">Not selected</span>
            </template>
          </template>

          <template #thead-top="data">
            <draggable
              tag="b-tr"
              v-model="fields"
              @change="changDraggable"
              draggable=".dragg"
              sortable="true"
              :sort="true"
            >
              <b-th
                v-for="(field, index) in fields"
                :key="index"
                class="draggable text-center"
                :class="[
                  {
                    'no-drag': !field.settings.drag,
                    dragg: field.settings.drag,
                    'b-table-sort-icon-left': field.sortable
                  }
                ]"
                style="padding: 0px 10px 10px 10px !important"
                :width="field.width"
              >
                <span class="drag-drop" v-if="field.settings.drag"> </span>
              </b-th>
            </draggable>
          </template>

          <template #cell(category)="data">
            <router-link
              :to="
                generateDetailRateLink(
                  data.item.rate._id,
                  data.item.rate.branch
                )
              "
              class="box-img-card"
              v-if="data.item.rate.vehicle"
            >
              <div class="img-car">
                <LazyImage
                  :src="data.item.rate.vehicle.information.image"
                  imgClasses="img-fluid es-img-service-2"
                  beforeClasses="img-car"
                  @click="openBox(data.index)"
                />
              </div>

              <div class="content ">
                <span class="capitalize hide-data title">
                  {{
                    formatCatergory(data.item.rate.vehicle.parameters.category)
                  }}
                </span>

                <span
                  class="hide-data subtitle-1"
                  v-if="data.item.rate.vehicle"
                  >{{ data.item.rate.vehicle.parameters.name }}</span
                >
                <span
                  class="hide-data subtitle-2"
                  v-if="data.item.rate.vehicle"
                  >{{
                    formatVehicleType(data.item.rate.vehicle.parameters.type)
                  }}</span
                >
              </div>
            </router-link>
          </template>

          <template #cell(destination)="data">
            <span class="hide-data role-table" v-if="data.item.rate.branch">{{
              data.item.rate.branch.supplier.businessDetails.name
            }}</span>
            <span class="hide-data" v-if="data.item.rate.branch"
              >{{ data.item.rate.branch.name }}
              <el-tooltip
                content="Affiliate"
                placement="bottom"
                v-if="isAffiliate(data.item.rate.branch)"
              >
                <i
                  class="flaticon-checkmark text-success d-inline-flex ml-1 f2"
                ></i>
              </el-tooltip>
            </span>
          </template>

          <template #cell(pricingSelections)="data">
            <span>
              {{ formatRateType(data.item.rate.type_of_quote) }}
            </span>
          </template>

          <template #cell(seats)="data">
            <span v-if="data.item.rate.vehicle">{{
              data.item.rate.vehicle.parameters.n_seats
            }}</span>
          </template>

          <template #cell(childSeats)="data">
            <span>{{ data.item.rate.child_seat.number }}</span>
          </template>

          <template #cell(childSeatPrice)="data">
            <span>
              {{ data.item.rate.currency_symbol }}
              {{ data.item.rate.child_seat.price }}
              {{ data.item.rate.currency_code }}
            </span>
          </template>

          <template #cell(currency)="data">
            <span>
              {{ data.item.rate.currency_code }}
            </span>
          </template>

          <template #cell(areas)="data">
            <span class="hide-data">{{
              getAreaOfActionLength(data.item.rate.area_of_action)
            }}</span>
          </template>

          <template #cell(especialConditions)="data">
            <span> {{ getSurcharges(data.item.rate.surcharges) }} </span>
          </template>

          <template #cell(minbasePriceByArea)="data">
            <div v-if="getAreaOfActionLength(data.item.rate.area_of_action)">
              <span
                >{{ data.item.rate.currency_symbol }}
                {{ getMinPrice(data.item.rate.area_of_action) }}
                {{ data.item.rate.currency_code }}</span
              >
            </div>
            <div v-else>
              <span
                >{{ data.item.rate.currency_symbol }}
                {{ addecimal(data.item.rate.base_price) }}
                {{ data.item.rate.currency_code }}</span
              >
            </div>
          </template>

          <template #cell(priceByDistance)="data">
            <span>
              {{ data.item.rate.currency_symbol }}
              {{ addecimal(data.item.rate.price_extra_km) }}
              {{ data.item.rate.currency_code }}
            </span>
          </template>

          <template #cell(validity)="data">
            <span class="d-block"
              ><strong>From: </strong>
              {{ getDateFormat(data.item.rate.validity_date.start) }}
            </span>
            <span class="d-block">
              <strong>To: </strong>
              {{ getDateFormat(data.item.rate.validity_date.end) }}
            </span>
          </template>

          <template #cell(status)="data">
            <span
              class="badge-status"
              v-bind:class="getClassByRateStatus(data.item.rate.status)"
            >
              {{ getRateStatus(data.item.rate.status) }}
            </span>
          </template>

          <template #cell(basePrice)="data">
            <span>
              {{ data.item.rate.currency_symbol }}
              {{ data.item.rate.base_price }}
              {{ data.item.rate.currency_code }}
            </span>
          </template>

          <template #cell(minimumDisposition)="data">
            <span v-if="data.item.rate.hours_disposition.status">
              {{ data.item.rate.hours_disposition.min_hours }}
            </span>
            <span v-else>
              N/A
            </span>
          </template>

          <template #cell(maximumDisposition)="data">
            <span v-if="data.item.rate.hours_disposition.max_hours">
              {{ data.item.rate.hours_disposition.max_hours }}
            </span>
            <span v-else>
              N/A
            </span>
          </template>

          <template #cell(distanceInclude)="data">
            <span v-if="data.item.rate.hours_disposition.status">
              {{ data.item.rate.hours_disposition.km_include }}
            </span>
            <span v-else>
              N/A
            </span>
          </template>

          <template #cell(priceByDisposition)="data">
            <span v-if="data.item.rate.hours_disposition.status">
              {{ data.item.rate.currency_symbol }}
              {{ data.item.rate.hours_disposition.price_by_hour }}
              {{ data.item.rate.currency_code }}
            </span>
            <span v-else>
              N/A
            </span>
          </template>

          <template #cell(meetAndGreetPrice)="data">
            <span>
              {{ data.item.rate.currency_symbol }}
              {{ data.item.rate.meet_greet_price }}
              {{ data.item.rate.currency_code }}
            </span>
          </template>

          <template #cell(actions)="data">
            <div class="action-column">
              <div class="button-action mr-2">
                <el-tooltip
                  content="History"
                  placement="bottom"
                  class="d-inline-flex"
                >
                  <span
                    class="icon-action text-blue "
                    @click.stop="openRateHistoryModal(data.item._id)"
                  >
                    <i class="flaticon-wall-clock-1"> </i>
                  </span>
                </el-tooltip>
              </div>
              <div class="drop-action d-inline-block">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="dropnocaret"
                  title="Actions"
                  :direction="getDirection(rates.docs, data.index)"
                >
                  <span slot="title"> <i class="flaticon-bold-kebab"></i></span>

                  <DropdownActionItem
                    :baseRoute="
                      generateDetailRateLink(
                        data.item.rate._id,
                        data.item.rate.branch
                      )
                    "
                    :canUpdate="canUserUpdate"
                    :canRead="canUserRead"
                    :editLabel="'Edit Rate'"
                    :viewLabel="'View Rate'"
                  />

                  <div
                    v-if="data.item.status && canUserUpdate"
                    class="dropdown-item"
                    @click.stop="
                      changeRateStatus(
                        data.item.rate._id,
                        data.item.rate.status
                      )
                    "
                  >
                    <span class="icon-action"
                      ><i class="flaticon-right-4 text-info"></i> Change
                      Status</span
                    >
                  </div>

                  <div
                    v-if="canUserCreate"
                    class="dropdown-item"
                    @click.stop="duplicateRate(data.item._id)"
                  >
                    <span class="icon-action">
                      <i class="flaticon-copy"></i>Duplicate
                    </span>
                  </div>

                  <div
                    v-if="canUserDelete"
                    class="dropdown-item"
                    @click.stop="deleteRate(data.item.rate._id)"
                  >
                    <span class="icon-action">
                      <i class="flaticon-delete text-danger"></i>Delete
                    </span>
                  </div>
                </base-dropdown>
              </div>
            </div>
          </template>
        </b-table>

        <pagination-block
          :pageCount="rates.pages"
          v-model="currentPage"
          :total="rates.count"
          :limit="limit"
          @changeLimit="changeLimit"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="preventPaginations"
          position="bottom"
        ></pagination-block>
      </div>
      <ManageTableColumns
        :value="modalManageColumn"
        :fields="fields"
        :tableGridConfig="tableGridConfig"
        :mandatories="['category', 'destination']"
        @saveColumns="saveColumnsInUserAccount"
        @closeTableGridModal="closeTableGridModal"
      />
    </div>
    <RateHistory
      :show="showRateHistory"
      :tempRateId="tempRateId"
      @close="closeRateHistoryModal"
    />
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
import Swal from "sweetalert2";
import {
  SettingsAPI,
  RatesAPI,
  ExportAPI,
  DocumentsAPI
} from "../../../core/api";
import moment from "moment";
import WSelect from "@/components/Select";
import RateHistory from "../components/RateHistory.vue";
import Pusher from "pusher-js";
import ManageTableColumns from "@/components/ManageTableColumns.vue";
import draggable from "vuedraggable";
import {
  goBack,
  isUserAuthorized,
  ROLE_HIERARCHY,
  setSigOut
} from "../../../helpers/commons.helpers";
import { RATE_TABLE_DEFAULTS } from "../../../core/constants";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "Rates",
  data() {
    return {
      branch: "",
      limit: 0,
      selectedRows: [],
      operators: [],
      branches: [],
      currentPage: 1,
      modal: false,
      modalManageColumn: false,
      fields: [],
      tableGridConfig: RATE_TABLE_DEFAULTS,
      cardview: false,
      view: "table",
      selected: [],
      currentBranch: null,
      sortBy: "",
      sortDesc: "asc",
      sortOptions: [
        { value: "currency", text: "Currency" },
        { value: "created_at", text: "Created At" }
      ],
      query: "",
      view: "table",
      tempRateId: null,
      showRateHistory: false,
      rateStatus: "ALL",
      pusher: null,
      filterStatus: "ALL",
      expired: 20,

      guides: [],
      loader: false,
      visibleSideBar: false
    };
  },
  watch: {
    branchesOptions: {
      handler: async function(current, old) {
        this.branches = current;
      },
      deep: true
    }
  },
  mounted() {
    Pusher.logToConsole = process.env.VUE_APP_ENV === "development";
    this.pusher = new Pusher(process.env.VUE_APP_PUSHER_API_KEY, {
      cluster: process.env.VUE_APP_PUSHER_CLUSTER
    });
    this.subscribe("rates");
  },
  async created() {
    this.fields = this.populateFields(this.settings);
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },

      {
        text: "Rates",
        active: true
      }
    ];
    this.setItemsBread(bread);
    await this.getLimit();
    this.limit = this.paginationLimit;
    this.query = this.rateSearchCriteria.query;
    this.currentPage = this.rateSearchCriteria.currentPage;
    let branch = this.getBranchId(
      this.rateSearchCriteria,
      this.$route.query.branch
    );
    if (this.branchesOptions.length <= 0) {
      await this.getBranchesOptions();
    } else {
      this.branches = this.branchesOptions;
    }
    this.branch = branch;
    await this.initFilters(this.query);
    this.initData(this.branch);
  },
  methods: {
    async changDraggable(column) {
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.rates.tableLayouts": this.fields }
      );
      if (status) {
        this.setSettings(settings);
      }
    },
    closeTableGridModal(status) {
      this.modalManageColumn = status;
    },
    async saveColumnsInUserAccount(fields = []) {
      this.modalManageColumn = false;
      this.fields = fields;
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.rates.tableLayouts": this.fields }
      );
      if (status) {
        this.$notify({
          type: "success",
          title: "Success!",
          message: "Columns have been changed",
          icon: "flaticon-check-3"
        });
        this.setSettings(settings);
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "Columns haven't been changed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async updateSettingLayoutsByUserId(userId, payload) {
      try {
        let { data } = await SettingsAPI.updateSettingLayoutsByUserId(
          userId,
          payload,
          this.sesion.token
        );
        if (data.status) {
          return { status: true, settings: data.data.settings };
        } else {
          return { status: false, settings: null };
        }
      } catch (error) {
        return { status: false, settings: null };
      }
    },
    populateFields(settings) {
      try {
        if (settings) {
          if (settings.rates.tableLayouts.length > 0) {
            return settings.rates.tableLayouts;
          }
        }
        return RATE_TABLE_DEFAULTS.filter(option => {
          return option.settings.default;
        });
      } catch (error) {
        return RATE_TABLE_DEFAULTS.filter(option => {
          return option.settings.default;
        });
      }
    },
    async selectedBranch(branchId) {
      if (branchId) {
        let branch = this.branchesOptions.find(
          element => element._id === branchId
        );
        this.currentBranch = branch;
        this.currentPage = 1;
        if (this.currentBranch) {
          this.$router.replace({ query: { branch: this.currentBranch._id } });
          await this.get(
            true,
            this.limit,
            this.currentPage,
            this.query,
            this.currentBranch ? this.currentBranch._id : null
          );
        }
      } else {
        this.$router.replace({ query: null });
        this.currentBranch = null;
        this.currentPage = 1;
        await this.get(true, this.limit, this.currentPage, this.query, null);
      }
    },
    async changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        let branch = this.currentBranch ? this.currentBranch._id : null;
        if (this.filterStatus === "ALL") {
          await this.get(
            true,
            this.limit,
            this.currentPage,
            this.query,
            branch
          );
        } else {
          await this.get(
            true,
            this.limit,
            this.currentPage,
            this.queryTemp,
            branch
          );
        }
      }
    },
    async preventPaginations(page) {
      let branch = this.currentBranch ? this.currentBranch._id : null;
      if (this.filterStatus === "ALL") {
        await this.get(true, this.limit, page, this.query, branch);
      } else {
        await this.get(true, this.limit, page, this.queryTemp, branch);
      }
    },
    async nextPaginations(page) {
      let branch = this.currentBranch ? this.currentBranch._id : null;
      if (this.filterStatus === "ALL") {
        await this.get(true, this.limit, page, this.query, branch);
      } else {
        await this.get(true, this.limit, page, this.queryTemp, branch);
      }
    },
    async changePage(page) {
      let branch = this.currentBranch ? this.currentBranch._id : null;
      if (this.filterStatus === "ALL") {
        await this.get(true, this.limit, page, this.query, branch);
      } else {
        await this.get(true, this.limit, page, this.queryTemp, branch);
      }
    },
    filterOptions(input) {
      if (input !== "" && input.length > 2) {
        this.branches = this.branchesOptions.filter(branch => {
          return branch.name.toLowerCase().indexOf(input.toLowerCase()) > -1;
        });
      } else {
        if (input === "") {
          this.branches = this.branchesOptions;
        } else {
          this.branches = [];
        }
      }
    },
    async deleteRate(rateId) {
      let { value } = await Swal.fire({
        title: "Delete Rate",
        text: "Are you sure do you want to delete this Rate?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteRateById(rateId);
      }
    },
    async deleteRateById(rateId) {
      try {
        this.setLoad(true);
        let { data } = await RatesAPI.deleteRateById(rateId, this.sesion.token);
        this.setLoad(false);
        if (data.data.deleted) {
          await this.get(
            true,
            this.limit,
            1,
            this.query,
            this.currentBranch ? this.currentBranch._id : null
          );
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Rate has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    async deleteMany(rates = []) {
      let { value } = await Swal.fire({
        title: "Delete Rates",
        text: "Are you sure do you want to delete the selected Rates?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteManyRatesById(rates);
      }
    },
    async deleteManyRatesById(rates = []) {
      try {
        this.setLoad(true);
        let { data } = await RatesAPI.deleteManyRatesById(
          { services: rates },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          await this.get(
            true,
            this.limit,
            1,
            this.query,
            this.currentBranch ? this.currentBranch._id : null
          );
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Rates has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    async download(rates = []) {
      try {
        this.setLoad(true);
        let { data } = await ExportAPI.exportCSVServices(
          { services: rates.map(item => item.rate) },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.code === 200) {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `rates-${moment().format("DD-MM-YYYY")}.csv`
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The data was not download. Please try again");
      }
    },
    getAreaOfActionLength(area_of_action) {
      if (area_of_action.length) {
        return area_of_action.length;
      } else {
        if (area_of_action.name != null) {
          return 1;
        }
      }
      return 0;
    },
    getMinPrice(areas = []) {
      let basePrice = areas.length
        ? Math.min(...areas.map(area => (area.price ? area.price : 0)))
        : 0;
      return basePrice.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    addecimal: function(price) {
      var total = price;
      return price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else if (data.code === 400) {
          if (data.error.code === "invalidData") {
            this.$notify({
              type: "warning",
              title: "Validation error!",
              message: `The file couldn't be uploaded. There is an error in the row ${data.error.value}. Please, correct this and upload the file again.`,
              icon: "flaticon-warning-1"
            });
          } else {
            this.$notify({
              type: "danger",
              title: "Error!",
              message: `The file couldn't be processed. Please, try again.`,
              icon: "flaticon-remove"
            });
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    getBranchId(rateSearchCriteria, queryBranchId) {
      if (rateSearchCriteria.branchId) {
        return rateSearchCriteria.branchId;
      } else {
        return queryBranchId ? queryBranchId : null;
      }
    },
    async initData(branchId) {
      let branch = this.branchesOptions.find(
        element => element._id === branchId
      );
      this.currentBranch = branch;
      await this.get(
        true,
        this.limit,
        1,
        this.query,
        this.currentBranch ? this.currentBranch._id : null
      );
    },
    async initFilters(query) {
      if (query) {
        let searchParams = new URLSearchParams(query);
        let rateStatus = searchParams.has("status")
          ? searchParams.get("status")
          : "";
        this.rateStatus = rateStatus !== "EXPIRED" ? rateStatus : "ALL";
        this.filterStatus = rateStatus === "EXPIRED" ? "EXPIRED" : "ALL";
      }
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    async get(loader, limit, page, query, branchId) {
      if (branchId) {
        await this.getRatesByBranchId({
          loader: loader,
          branchId: branchId,
          limit: limit,
          page: page,
          query: query
        });
      } else {
        await this.getRates({
          loader: loader,
          limit: limit,
          page: page,
          query: query
        });
      }
      this.setRateSearchCriteria({
        status: true,
        branchId: branchId,
        limit: limit,
        page: page,
        query: query
      });
    },
    async applySortBy(value) {
      this.query = this.addElementInQuery(this.query, "sortBy", value);
      this.query = this.addElementInQuery(
        this.query,
        "sortType",
        this.sortDesc
      );
      let branch = this.currentBranch ? this.currentBranch._id : null;
      if (this.filterStatus === "ALL") {
        await this.get(true, this.limit, this.currentPage, this.query, branch);
      } else {
        await this.get(
          true,
          this.limit,
          this.currentPage,
          this.queryTemp,
          branch
        );
      }
    },
    async applySortType(value) {
      this.query = this.addElementInQuery(this.query, "sortType", value);
      let branch = this.currentBranch ? this.currentBranch._id : null;
      if (this.filterStatus === "ALL") {
        await this.get(true, this.limit, this.currentPage, this.query, branch);
      } else {
        await this.get(
          true,
          this.limit,
          this.currentPage,
          this.queryTemp,
          branch
        );
      }
    },
    async applyFilterByStatus(status) {
      this.rateStatus = status;
      this.query =
        status !== "ALL"
          ? this.addElementInQuery(this.query, "status", status)
          : this.deleteItemInQuery(this.query, ["status"]);
      this.filterStatus = "ALL";
      this.currentPage = 1;
      let branch = this.currentBranch ? this.currentBranch._id : null;
      await this.get(true, this.limit, this.currentPage, this.query, branch);
    },
    async filteredTab(value) {
      if (value === "ALL") {
        this.currentPage = 1;
        this.queryTemp = "";
        let branch = this.currentBranch ? this.currentBranch._id : null;
        this.query =
          this.rateStatus === "ALL"
            ? this.deleteItemInQuery(this.query, ["status"])
            : this.addElementInQuery(this.query, "status", this.rateStatus);
        await this.get(true, this.limit, this.currentPage, this.query, branch);
      } else {
        this.currentPage = 1;
        if (this.expiredNumber > 0) {
          let branch = this.currentBranch ? this.currentBranch._id : null;
          this.queryTemp = this.addElementInQuery(this.query, "status", value);
          await this.get(
            true,
            this.limit,
            this.currentPage,
            this.queryTemp,
            branch
          );
        } else {
          this.rates.docs = [];
        }
      }
    },
    addElementInQuery(query, key, value) {
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, value ? value.trim() : value);
      } else {
        searchParams.append(key, value ? value.trim() : value);
      }
      return searchParams.toString();
    },
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },
    isAffiliate(branch) {
      if (branch) {
        return branch.supplier ? branch.supplier.affiliate : false;
      } else {
        return false;
      }
    },
    getSurcharges(surcharges = []) {
      if (surcharges.length) {
        return surcharges.length;
      } else {
        return 0;
      }
    },
    typeEvent(type) {
      if (type === "blackouts") {
        return "Blackouts Dates";
      } else if (type === "special_event") {
        return "Special Event";
      } else if (type === "weekend_dates") {
        return "Weekend Fees";
      } else if (type === "night_fees") {
        return "Night Fees";
      } else if (type === "seasonal") {
        return "Seasonal Fees";
      }
    },
    async downloadFormatToUpdateRates(branchId) {
      try {
        this.setLoad(true);
        let { data } = await ExportAPI.requestTheFormatToUpdateRates(
          branchId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.code === 200) {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `rates-${branchId}-${moment().format("DD-MM-YYYY")}.csv`
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The data was not download. Please try again");
      }
    },
    upload() {
      this.$refs.fileInput.click();
    },
    async updatedRatesByBranch(event) {
      try {
        const [file] = event.target.files;
        if (file) {
          let formData = new FormData();
          formData.append("file", file);
          this.setLoad(true);
          let { data } = await ExportAPI.updateRates(
            formData,
            this.sesion.token
          );
          this.setLoad(false);
          this.$refs.fileInput.value = null;
          if (data.status) {
            this.$notify({
              type: "success",
              title: "Success!",
              message: "The Rates has been Updated",
              icon: "flaticon-check-3"
            });
            await this.get(
              true,
              this.limit,
              this.currentPage,
              this.query,
              this.currentBranch ? this.currentBranch._id : null
            );
          } else {
            this.$notify({
              type: "danger",
              title: "Error!",
              message: "The data was not download. Please try again",
              icon: "flaticon-remove"
            });
          }
        } else {
          event.preventDefault();
        }
      } catch (error) {
        this.$refs.fileInput.value = null;
        this.setLoad(false);
        this.handleError(
          error,
          "There was an error while uploading the file. Please, try again."
        );
      }
    },
    changeViewCard() {
      if (this.view === "table") {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    isInRateModule(modules = []) {
      if (!(modules.indexOf("rates") > -1)) {
        this.setRateSearchCriteria({
          currentPage: 1,
          limit: 15,
          branchId: null,
          query: "",
          status: false
        });
      }
    },
    async onRowClicked(item) {
      const { detailsRow } = this;
      if (detailsRow && detailsRow !== item) {
        detailsRow._showDetails = false;
      }
      this.$set(item, "_showDetails", !item._showDetails);
      this.detailsRow = item;
    },
    getDestinationName(destination) {
      try {
        if (destination.supplier.businessDetails.name) {
          return `${destination.name} - ${destination.supplier.businessDetails.name}`;
        } else {
          return `${destination.name}`;
        }
      } catch (error) {
        return `${destination.name}`;
      }
    },
    openRateHistoryModal(rateId) {
      this.tempRateId = rateId;
      this.showRateHistory = !this.showRateHistory;
    },
    closeRateHistoryModal() {
      this.showRateHistory = false;
      this.tempRateId = null;
    },
    getClassByRateStatus(status) {
      if (status === "ACTIVE") {
        return "badge-success";
      } else if (status === "INACTIVE") {
        return "badge-danger";
      } else if (status === "EXPIRED") {
        return "status-draft";
      } else {
        return {};
      }
    },
    getRateStatus(status) {
      if (status === "ACTIVE") {
        return "Active";
      } else if (status === "INACTIVE") {
        return "Inactive";
      } else if (status === "EXPIRED") {
        return "Expired";
      } else {
        return "Unknow";
      }
    },
    async changeRateStatus(rateId, status) {
      if (status !== "EXPIRED") {
        let { value } = await Swal.fire({
          title: "Change Status Rate",
          html:
            "Are you sure you want to <strong>Change Status</strong> of the selected Rate?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",

          onClose: () => {
            setTimeout(() => {}, 1500);
          }
        });
        if (value) {
          await this.changeRateStatusById(
            rateId,
            status === "ACTIVE" ? "INACTIVE" : "ACTIVE"
          );
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Validation error!",
          message: `The Rate couldn't be uploaded. Please update the validity period of this rate.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async changeRateStatusById(rateId, status) {
      try {
        this.setLoad(true);
        let { data } = await RatesAPI.updateAnyAttributeById(
          rateId,
          { status: status },
          this.sesion.token
        );
        this.setLoad(false);
        if (data) {
          await this.get(
            false,
            this.limit,
            this.currentPage,
            this.query,
            this.currentBranch ? this.currentBranch._id : null
          );
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Rate Status has been Updated",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation couldn't be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    subscribe(event) {
      var channel = this.pusher.subscribe("rhombuss");
      let roles = ROLE_HIERARCHY;
      channel.bind(event, async data => {
        if (roles.indexOf(this.sesion.role) > -1 && data.type === "admin") {
          await this.get(
            false,
            this.limit,
            this.currentPage,
            this.query,
            this.currentBranch ? this.currentBranch._id : null
          );
        }
      });
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async openSideBar() {
      this.visibleSideBar = true;
      this.loader = true;
      this.guides = await this.getSupportDocuments("INTERNAL", "RATES");
      this.loader = false;
    },
    async getSupportDocuments(app, module) {
      try {
        let { data } = await DocumentsAPI.getSupportDocuments(
          app,
          module,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    formatCatergory(type) {
      if (type === "standard") {
        return "Standard Class";
      } else if (type === "business") {
        return "Business Class";
      } else {
        return "Luxury Class";
      }
    },
    formatVehicleType(type) {
      if (type === "sedan") {
        return "Sedan";
      } else if (type === "boat") {
        return "Boat";
      } else if (type === "coach") {
        return "Coach";
      } else if (type === "limousine") {
        return "Limousine";
      } else if (type === "minibus") {
        return "Minibus";
      } else if (type === "midicoach") {
        return "Midicoach";
      } else if (type === "minivan") {
        return "Minivan";
      } else if (type === "mpv") {
        return "Mpv";
      } else if (type === "pickup") {
        return "Pickup";
      } else if (type === "premium_sedans") {
        return "Premium Sedans";
      } else if (type === "suvs") {
        return "SUVs";
      }
    },
    formatRateType(type) {
      if (type === "travel") {
        return "By Distance";
      } else {
        return "Area + Distance";
      }
    },
    async duplicateRate(rateId) {
      let { value } = await Swal.fire({
        title: "Duplicate Rate!",
        text: "Are you sure you want to duplicate this Rate?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",
        cancelButtonClass: "btn btn-secondary btn-small-one",
        confirmButtonText: "Yes",
        confirmButtonClass: "btn btn-primary btn-small-one",
        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        this.$router.push({
          path: `/rates/new`,
          query: { duplicateRate: rateId }
        });
      }
    },
    getDirection: function(products = [], index) {
      if (products.length >= 5) {
        let position = products.length - index;
        if (position === 5) {
          return "down";
        } else {
          return position > 5 ? "down" : "up";
        }
      } else {
        return "down";
      }
    },
    getDateFormat(date) {
      return moment.utc(date, "YYYY-MM-DD").format("DD-MMM-YYYY");
    },
    generateDetailRateLink(rateId, branch) {
      if (rateId && branch) {
        return `/rates/${rateId}?branch=${branch._id}&operator=${branch.supplier._id}`;
      }
      return `/rates/${rateId}`;
    },
    ...mapActions([
      "getOperatorsOptions",
      "getBranchesOptionsByOperatorId",
      "getRatesByBranchId",
      "getBranchesOptions",
      "getRates",
      "getLimit"
    ]),
    ...mapMutations([
      "setRatesOfBranch",
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setRateSearchCriteria",
      "setSettings"
    ])
  },
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    WSelect,
    RateHistory,
    ManageTableColumns: ManageTableColumns,
    draggable
  },
  computed: {
    items: function() {
      try {
        let rates = this.rates.docs || [];
        return rates.map(rate => {
          return {
            _id: rate._id,
            category: rate.vehicle ? rate.vehicle.parameters.category : "",
            destination: rate.branch ? rate.branch.name : "",
            pricingSelections:
              rate.type_of_quote === "area" ? "Area + Distance" : "By Distance",
            seats: rate.vehicle ? rate.vehicle.parameters.n_seats : 0,
            childSeats: rate.child_seat.number,
            childSeatPrice: rate.child_seat.price,
            areas: this.getAreaOfActionLength(rate.area_of_action),
            especialConditions: rate.surcharges.length,
            minbasePriceByArea: this.getMinPrice(rate.area_of_action),
            validity: `From: ${this.getDateFormat(
              rate.validity_date.start
            )} To: ${this.getDateFormat(rate.validity_date.end)}`,
            status: rate.status,
            basePrice: rate.base_price,
            priceByDistance: rate.price_extra_km,
            currency: rate.currency_code,
            minimumDisposition: rate.hours_disposition.min_hours,
            distanceInclude: rate.hours_disposition.km_include,
            priceByDisposition: rate.hours_disposition.price_by_hour,
            meetAndGreetPrice: rate.meet_greet_price,
            rate: rate
          };
        });
      } catch (error) {
        return [];
      }
    },
    expiredNumber: function() {
      if (this.rates.metadata) {
        return this.rates.metadata.expired;
      } else {
        return 0;
      }
    },
    ...mapGetters([
      "branchesOptionsByOperatorId",
      "ratesOfBranch",
      "branchesOptions",
      "sesion",
      "userRole",
      "sigout",
      "rates",
      "paginationLimit",
      "rateSearchCriteria",
      "settings"
    ]),
    canUserDelete() {
      return isUserAuthorized("RATES", this.userRole, "DELETE");
    },
    canUserCreate() {
      return isUserAuthorized("RATES", this.userRole, "CREATE");
    },
    canUserUpdate() {
      return isUserAuthorized("RATES", this.userRole, "UPDATE");
    },
    canUserRead() {
      return isUserAuthorized("RATES", this.userRole, "READ");
    },
    canUserExport() {
      return isUserAuthorized("RATES", this.userRole, "EXPORT");
    }
  },
  destroyed() {
    if (this.pusher !== null) {
      this.pusher.disconnect();
    }
  },
  beforeRouteLeave(to, from, next) {
    this.isInRateModule(to.meta.modules);
    next();
  }
};
</script>
